const spaceName = 'CollectorHub-Dev'

export const config = {
  spaceName: {
    app: spaceName,
    NFTComments: spaceName + '-nft-comments'
  },
  usrKeys: {
    profileTitle: spaceName + '-profile-title',
    following:  spaceName + '-following',
  },
  localStorageKey: {
    login: 'userAddress',
  },
  openSeaAPI: {
    headers: {
    },
    url: {
      getAssets: 'https://api.opensea.io/api/v1/assets/'
    }
  },
  defaultRedirect: {
    publicHome: 'public-home',
    appHome: 'app-home'
  }
}
